import { get, post, put } from '..'
import { createUploadHanlder } from './files'
import type {
  SecondDegree,
  CreateSecondDegreeEnrollPayload
} from '@/models/enrolls/secondDegree'

const API_URL = 'student/SecondDegreeEnroll'

export async function fetchSecondDegreeEnroll() {
  const { data } = await get(`${API_URL}/self`)
  return data as SecondDegree
}

export async function updateSecondDegreeEnroll(form: SecondDegree) {
  form.sex = form.sex.toString()
  const { data } = await put(`${API_URL}/self`, form)
  return data as SecondDegree
}

export async function createSecondDegreeEnroll(
  form: CreateSecondDegreeEnrollPayload
) {
  form.sex = form.sex.toString()
  const { data } = await post(`${API_URL}/self`, form)
  return data as SecondDegree
}

/**
 * 上传文件
 * @param file 文件
 * @param onUploadProgress 监听进度
 * @returns 文件路径
 */
export const uploadSecondDegreeFile = createUploadHanlder(`${API_URL}/files`)
